export default function getAddressFields(address, addressTypes) {
    return {
      address_id: address.id || null,
      fields: [
        {
          label: 'Address type',
          column_name: 'type',
          value: address.type || '',
          type: 'select',
          icon: '',
          options: addressTypes
        },
        {
          label: 'Address 1',
          column_name: "street_address_1",
          value: address.street_address_1 || '',
          type: 'text',
          icon: ''
        },
        {
          label: 'Address 2',
          column_name: "street_address_2",
          value: address.street_address_2 || '',
          type: 'text',
          icon: ''
        },
        {
          label: 'City',
          column_name: 'city',
          value: address.city || '',
          type: 'text',
          icon: ''
        },
        {
          label: 'State',
          column_name: 'state',
          value: address.state || '',
          type: 'text',
          icon: ''
        },
        {
          label: 'Zip/Postal',
          column_name: 'zip',
          value: address.zip || '',
          type: 'text',
          icon: ''
        },
      ]
    }
  }
